import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const EmailUserAvatarIcon = (props: IconProps) => (
  <Icon w="32px" h="32px" viewBox="0 0 32 32" {...props}>
    <circle cx="16" cy="16" r="16" />
    <path
      fill="#fff"
      d="M26.9333 12.6667c0-.8066-.6545-1.4666-1.4545-1.4666H13.8424c-.8 0-1.4545.66-1.4545 1.4666l-1.4546 8.8c0 .8067.6546 1.4667 1.4546 1.4667h11.6364c.8 0 1.4545-.66 1.4545-1.4667l1.4545-8.8Zm-1.4545 0-5.8182 3.6667-5.8182-3.6667h11.6364Zm-1.4545 8.8H12.3879l1.4545-7.3333 5.8182 3.6667 5.8182-3.6667-1.4545 7.3333Z"
    />
    <rect
      width="7.46667"
      height="1.06667"
      x="3.46655"
      y="12.2667"
      fill="#fff"
      rx=".533334"
    />
    <rect
      width="4.26667"
      height="1.06667"
      x="5.59985"
      y="15.4667"
      fill="#fff"
      rx=".533333"
    />
    <rect
      width="2.13333"
      height="1.06666"
      x="6.6665"
      y="18.6667"
      fill="#fff"
      rx=".533332"
    />
  </Icon>
);

export default memo(EmailUserAvatarIcon);
